import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  Col,
  Label,
  Modal,
  ModalBody,
  Row,
  FormGroup,
  ModalFooter,
} from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import { AvField, AvForm } from "availity-reactstrap-validation";
import Slider from "rc-slider";
import CustomMultipleDateRange from "../../../../../components/CustomMultipleDateRange/CustomMultipleDateRange";

const PayoutModal = ({
  isOpen,
  toggle,
  editData,
  permissions,
  updatePayout,
  addPayout,
}) => {
  const [sliderData, setSliderData] = React.useState([100, 900]);
  const [payPercent, setPayPercent] = React.useState("");
  const [dateRange, setDateRange] = React.useState({});

  React.useEffect(() => {
    if (editData !== null && isOpen) {
      setSliderData([editData?.min_percent, editData?.max_percent]);
      setPayPercent(editData?.pay_percent);
      setDateRange({
        start_date:
          editData?.date_from == null ? undefined : editData?.date_from,
        end_date: editData?.date_to == null ? undefined : editData?.date_to,
      });
    } else {
      setSliderData([100, 900]);
    }
  }, [isOpen]);

  const handleValidOrderSubmit = (e, errors, params) => {
    if (errors?.length === 0) {
      let percents = {
        min_percent: params.min_percent,
        max_percent: params.max_percent,
        pay_percent: params.pay_percent,
        date_from: dateRange.start_date,
        date_to: dateRange.end_date,
      };

      if (editData !== null) {
        (percents["id"] = editData?.id), updatePayout([percents]);
        toggle();
      } else {
        addPayout(percents);
        toggle();
      }
    }
  };

  const changeSliderData = arr => {
    setSliderData(arr);
  };

  const changeInputs = (i, val) => {
    let currentData = sliderData;
    currentData[i] = Number(val) || 0;
    setSliderData([currentData[0], currentData[1]]);
  };

  const validateRange = (value, ctx) => {
    if (sliderData[0] > ctx.max_percent) {
      return " ";
    } else if (sliderData[1] < ctx.min_percent) {
      return " ";
    } else {
      return true;
    }
  };

  return (
    <Modal isOpen={isOpen} size="sm" autoFocus centered toggle={toggle}>
      <AvForm className="needs-validation" onSubmit={handleValidOrderSubmit}>
        <div className="modal-header">
          <h4 className="modal-title mt-0" id="myModalLabel">
            {editData !== null ? "Edit" : "Add"} payout condition
          </h4>
          <button
            type="button"
            onClick={toggle}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <ModalBody>
          <Row form>
            <Col sm={12}>
              <Col sm>
                <Label htmlFor="">Date:</Label>
                <FormGroup className="mb-3">
                  <CustomMultipleDateRange
                    placeholder="Select date..."
                    name="month"
                    defaultText={editData !== null ? dateRange : null}
                    datePickerType={"round-with-present"}
                    errorText=" "
                    onChange={e => setDateRange(e)}
                    required
                  />
                </FormGroup>
              </Col>
              <Col sm>
                <FormGroup className="mb-3">
                  <Label>Payout percent</Label>
                  <AvField
                    name="pay_percent"
                    type="number"
                    placeholder="Payout percent..."
                    errorMessage="This value is required"
                    value={payPercent}
                    onChange={e => setPayPercent(e.target.value)}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Please, enter payout percent",
                      },
                      max: {
                        value: 1000,
                        errorMessage: "Max value is 1000 percents",
                      },
                    }}
                  />
                </FormGroup>
              </Col>
              <Row>
                <Label>Min/Max percents</Label>
              </Row>
              <Row className="justify-content-center">
                <Col mb={6}>
                  <FormGroup className="mb-3">
                    <AvField
                      value={sliderData[0]}
                      name="min_percent"
                      type="number"
                      errorMessage="This value is required"
                      onChange={e => changeInputs(0, e.target.value)}
                      validate={{
                        required: {
                          value: true,
                          errorMessage: "Can't be empty",
                        },
                        min: {
                          value: 0,
                        },
                        max: {
                          value: 1000,
                        },
                        // checkRange: validateRange,
                      }}
                    />
                  </FormGroup>
                </Col>
                <Tire>-</Tire>
                <Col mb={6}>
                  <FormGroup className="mb-3">
                    <AvField
                      value={sliderData[1]}
                      name="max_percent"
                      type="number"
                      errorMessage="This value is required"
                      onChange={e => changeInputs(1, e.target.value)}
                      validate={{
                        required: {
                          value: true,
                          errorMessage: "Can't be empty",
                        },
                        min: {
                          value: 0,
                        },
                        max: {
                          value: 1000,
                        },
                        checkRange: validateRange,
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col sm={12}>
                  <Slider
                    range
                    min={0}
                    max={1000}
                    step={0.5}
                    allowCross={false}
                    value={sliderData}
                    onChange={e => changeSliderData(e)}
                    railStyle={{ backgroundColor: "#ced4da" }}
                    trackStyle={{ backgroundColor: "#34c38f" }}
                    handleStyle={{
                      borderColor: "#34c38f",
                      backgroundColor: "#ced4da",
                    }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                {permissions?.["change_managerpayoutconditionmodel"] && (
                  <button
                    type="submit"
                    className="btn btn-success save-user ms-2"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

const Tire = styled.span`
  position: relative;
  width: 10px;
  vertical-align: middle;
  right: 4px;
  top: 8px;
`;

PayoutModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  permissions: PropTypes.object.isRequired,
  editData: PropTypes.any,
  updatePayout: PropTypes.func,
  addPayout: PropTypes.func,
};

export default PayoutModal;
